(function () {
    'use strict';

    angular.module('thankview.global')
        .directive('overlayMessage', ['$rootScope', '$sce', function ($rootScope, $sce) {
            return {
                restrict: 'E',
                templateUrl: '/templates/global/overlay-message.html?v=' + config.version,
                scope: true,
                link: function (scope) {
                    scope.$on('open-message-confirm', function ($event, message, deferred, params) {
                        var buttons = [
                            { name: 'Cancel', colorClass: 'btn--cancel', callback: function () { deferred.reject(); } },
                            { name: 'Continue', colorClass: 'btn--primary', callback: function () { deferred.resolve(); } },
                        ];

                        scope.showLoader = false;
                        scope.header = params && params.header ? params.header : 'Are You Sure?';
                        scope.headerIcon = params && params.headerIcon ? params.headerIcon : '';
                        scope.headerClasses = params && params.headerClasses ? params.headerClasses : [];
                        scope.message = $sce.trustAsHtml(message);

                        scope.params = {
                            buttons: buttons,
                        };

                        if (params) {
                            scope.params = angular.extend(scope.params, params);
                        }
                        scope.openOverlay();
                    });

                    scope.$on('open-message', function ($event, message, params) {
                        scope.showLoader = false;
                        scope.header = params && params.header ? params.header : '';
                        scope.headerIcon = params && params.headerIcon ? params.headerIcon : '';
                        scope.headerClasses = params && params.headerClasses ? params.headerClasses : [];

                        scope.message = $sce.trustAsHtml(message);
                        scope.params = params || {};

                        $rootScope.$broadcast('close-loading');

                        scope.openOverlay();
                    });

                    scope.openOverlay = function () {
                        // set default parameters
                        if (scope.params) {
                            scope.dontClose = scope.params.dontClose ? scope.params.dontClose : false;

                            if (!scope.params.buttons && !scope.dontClose) {
                                scope.params.buttons = [
                                    { name: 'Okay' },
                                ];
                            }

                            let buttonMarkup = '';

                            angular.forEach(scope.params.buttons, function (b, index) {
                                // if we have multiple buttons and this isn't the last one, add a right margin
                                const marginClass = (index < scope.params.buttons.length - 1) ? 'margin-r-16px' : '';
                                const btnIcon = b.icon ? `<i class="${b.icon} pad-r-4px"></i>` : '';
                                if (b.href) {
                                    const target = b.target ? `target="${b.target}" rel="noopener noreferrer"` : '';
                                    const clickHandler = b.callback ? `ng-click="buttonClick($event, ${index})"` : '';
                                    const standardBtn = b.colorClass && b.colorClass.includes('text-dec-underline') ? '' : 'btn';
                                    buttonMarkup += `<a class="${standardBtn} ${b.colorClass || 'btn--primary'} ${marginClass}" href="${b.href}" ${target} ${clickHandler}>${btnIcon}${b.name}</a>`;
                                } else {
                                    buttonMarkup += `<button type="button" class="btn ${b.colorClass || 'btn--primary'} ${marginClass}" ng-click="buttonClick($event, ${index})">${btnIcon}${b.name}</button>`;
                                }
                            });

                            scope.buttonMarkup = buttonMarkup;
                        }

                        scope.$broadcast('open-overlay');
                    };

                    scope.$on('close-message', function () {
                        scope.$broadcast('force-close-overlay');
                    });

                    // index is the index of the provided button in scope.params.buttons
                    scope.buttonClick = function ($event, index) {
                        const button = scope.params.buttons[index];
                        const callback = button.callback;
                        if (callback && typeof callback === 'function') {
                            callback();
                        } else {
                            $event.preventDefault();
                        }
                        if (!button.dontClose) {
                            scope.$broadcast('force-close-overlay');
                        }
                    };
                },
            };
        }]);
}());
